// cms modull sliderProducts: Artikel als Slider anzeigen... farbicon zum change der artikel, danach muessen die events neu gesetzt werden
import Splide from '@splidejs/splide';
import { ErrorReporter } from "../common/errorReporter";

export class SliderProducts {
    private productSliders: NodeListOf<Element>;

    constructor() {
        this.productSliders = document.querySelectorAll('.productSliderContainer');

        if (this.productSliders.length > 0) {
            this.initializeSliders();
        }
    }

    private initializeSliders(): void {
        this.productSliders.forEach((productSlider) => {
            const id = productSlider.getAttribute('data-slider-id') ?? ''; // Standardwert: leeres String
            const productLimit = productSlider.getAttribute('data-slider-limit') ?? '0'; // Standardwert: 0
            const type = productSlider.getAttribute('data-slider-type') ?? ''; // Standardwert: leeres String
            const sliderNav = productSlider.getAttribute('data-slider-nav') ?? 'false'; // Standardwert: 'false'
            const rewind = productSlider.getAttribute('data-slider-rewind') ?? 'false'; // Standardwert: 'false'

            const rewindBoolean = (rewind === 'true');
            const navBoolean = (sliderNav === 'true');

            // ueberpruefen, ob alle erforderlichen Attribute vorhanden sind
            if (!type || !productLimit || !sliderNav) {
                return; // Notwendige Attribute fehlen
            }

            const limit = parseInt(productLimit, 10);
            document.querySelectorAll(`#productSlider-${id}.splide`).forEach(slider => {

                if (!slider.classList.contains('is-initialized')) {
                    slider.classList.add('is-initialized');

                    // Ein neuer Splide-Slider wird mit den folgenden Einstellungen initialisiert
                    new Splide(slider as HTMLElement, {
                        type: type,
                        speed: 500,
                        perPage: limit >= 5 ? 5 : limit,
                        perMove: 1,
                        gap: 0,
                        rewind: rewindBoolean,
                        width: '100%',
                        start: limit < 2 ? 1 : 0,
                        pagination: navBoolean,
                        arrows: true,
                        lazyLoad: 'sequential',
                        classes: {
                            arrows: 'controls tns-controls',
                            prev: 'splide__arrow--prev controls-prev prev',
                            next: 'splide__arrow--next controls-next next',
                            pagination: 'splide__pagination tns-nav',
                        },
                        breakpoints: {
                            559: {
                                perPage: 1,
                            },
                            1023: {
                                perPage: 2,
                            },
                            1289: {
                                perPage: 3,
                            }
                        },
                    }).mount();
                }
            });

            document.querySelector(`#productSlider-${id}`)?.classList.remove('initialstate');

            // Aufruf der neuen Methode zum Setup der Slider-Events
            this.initSliderEvents(productSlider, id);
        });
    }

    private initSliderEvents(productSlider: Element, id: string): void {
        const sliderListItems = productSlider.querySelectorAll(`#productSlider-${id} .colors_memory li`);

        if (sliderListItems.length < 1) {
            return;
        }

        sliderListItems.forEach((sliderListItem) => {
            sliderListItem.addEventListener('click', (event) => {
                event.preventDefault();
                const target = event.target as HTMLElement;
                this.changeArticle(target, id);
            });
        });
    }

    private preloadImage(url: string): void {
        const img = new Image();
        img.src = url;
    }

    private async changeArticle(element: HTMLElement, id: string): Promise<void> {
        const listElement = element.closest('li');
        const imgurl = listElement?.dataset.imageurl ?? ''; // Standardwert: leeres String

        if (imgurl) {
            this.preloadImage(imgurl);
        }

        const artid = listElement?.dataset.artid; // artid kann null sein
        const container = element.closest('li.product-item .item');

        if (!artid || !container) {
            return;
        }

        const apiurl = '/artikel/show_article_for_slider/' + artid;
        const form = element.closest('form');

        if (!form) {
            return;
        }

        const data = new FormData(form);
        const settings: RequestInit = {
            method: 'POST',
            headers: { "X-Requested-With": "XMLHttpRequest" },
            cache: 'default', // Stellen Sie sicher, dass dies einen gueltigen RequestCache-Wert hat
            body: data,
            credentials: 'same-origin'
        };

        try {
            const response = await fetch(apiurl, settings);

            if (response.ok) {
                const html = await response.text();
                container.innerHTML = html;
                this.initSliderEvents(container, id); // Neu initialisieren
            }
        } catch (error) {
            this.handleError(error, apiurl);
        }
    }

    private handleError(error: unknown, apiurl: string): void {
        const errorReporter = new ErrorReporter();

        if (error instanceof Error) {
            errorReporter.reportError(
                error.message,
                apiurl,
                null,
                null,
                error.stack ?? null
            );
        } else {
            errorReporter.reportError(
                typeof error === 'string' ? error : "Error of unknown type",
                apiurl,
                null,
                null,
                null
            );
        }
    }
}
